/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Run_Approval_DestructiveInputs */



/**
* | output |
* | --- |
* | "Irreversible" |
*
* @param {Agent_Run_Approval_DestructiveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_run_approval_destructive = /** @type {((inputs?: Agent_Run_Approval_DestructiveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Run_Approval_DestructiveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Unumkehrbar")
	return /** @type {LocalizedString} */ ("Irreversible")
});